import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ShoppingBagIcon, XIcon } from 'lucide-react';
import { MOCKUP_URL, buyers } from '../data/content';
type Notice = {
  name: string;
  country: string;
  minutes: number;
};
export function PurchasePopup() {
  const [notice, setNotice] = useState<Notice | null>(null);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    let index = Math.floor(Math.random() * buyers.length);
    let hideTimer: number | undefined;
    const show = () => {
      const b = buyers[index % buyers.length];
      index += 1;
      setNotice({
        ...b,
        minutes: 1 + Math.floor(Math.random() * 14)
      });
      hideTimer = window.setTimeout(() => setNotice(null), 5000);
    };
    const first = window.setTimeout(show, 6000);
    const loop = window.setInterval(show, 14000);
    return () => {
      window.clearTimeout(first);
      window.clearInterval(loop);
      if (hideTimer) window.clearTimeout(hideTimer);
    };
  }, [dismissed]);
  return <div className="pointer-events-none fixed bottom-[92px] left-3 right-3 z-50 flex sm:left-5 sm:right-auto" aria-live="polite" data-id="element-271" data-mp="163mpzd5zo90u">
      <AnimatePresence data-id="element-272" data-mp="1fw24u1lzohhi">
        {notice && !dismissed && <motion.div key={notice.name + notice.minutes} initial={{
        opacity: 0,
        y: 16,
        scale: 0.96
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 16,
        scale: 0.96
      }} transition={{
        duration: 0.22,
        ease: [0.23, 1, 0.32, 1]
      }} className="pointer-events-auto relative flex w-full max-w-sm items-center gap-3 rounded-2xl bg-white p-3 pr-9 shadow-2xl ring-1 ring-navy-900/10" data-id="element-273" data-mp="1fxn0xvnyc8hh">
            <img src={MOCKUP_URL} alt="" className="h-14 w-14 shrink-0 rounded-lg bg-ivory object-contain" data-id="element-274" data-mp="s4n1c5ih7u4o" />
            <div className="min-w-0" data-id="element-275" data-mp="28imyj8pxt5o8">
              <p className="text-sm leading-snug text-ink" data-id="element-276" data-mp="23lmybefrqx51">
                <strong className="text-navy-900" data-id="element-277" data-mp="23nhbg6kstkyk">{notice.name}</strong> from{' '}
                <strong className="text-navy-900" data-id="element-278" data-mp="2ao1n2xww5ppr">{notice.country}</strong> just purchased the Veneer
                Complications Blueprint™
              </p>
              <p className="mt-0.5 flex items-center gap-1 text-xs font-semibold text-emerald-700" data-id="element-279" data-mp="2km7pdgmm0xv5">
                <ShoppingBagIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-280" data-mp="2pmdil18j2sfc" />
                {notice.minutes} min ago · Verified purchase
              </p>
            </div>
            <button type="button" onClick={() => setDismissed(true)} className="absolute right-2 top-2 rounded-full p-1 text-muted hover:bg-ivory" aria-label="Close notification" data-id="element-281" data-mp="1rw8wtb97iilq">
              <XIcon className="h-4 w-4" data-id="element-282" data-mp="26nrinpoqz7d0" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}